/* Menú, consola, proceso, portafolio y testimonios. Van aparte del módulo
   del telar a propósito: si Three.js no carga —sin WebGL, con el ahorro de
   datos, o porque falló la red— el menú tiene que seguir abriéndose y el
   diagnóstico seguir midiendo. La decoración nunca puede llevarse por
   delante la función.

   Una IIFE por pieza, sin variables globales, y cada una comprueba que su
   elemento exista antes de tocarlo. Todas dentro de una exterior que solo
   reparte los textos.

   Los textos no viven aquí. Llegan en `<script type="application/json"
   id="tx">`, que la página pone en la cabeza con el diccionario de SU idioma
   (`tema-src/textos/cliente.<idioma>.js`): un solo archivo de comportamiento
   para las dos portadas, y cada visitante baja solo las palabras que lee. Si
   el bloque falta, `t()` devuelve la clave: se ve feo, pero nada se rompe. */
(function(){
'use strict';
var TX = {};
try { TX = JSON.parse(document.getElementById('tx').textContent) || {}; } catch (e) {}
/* El idioma sale del `lang` del documento: `es-…` es español, lo demás
   inglés. El `lang` entero es además el locale de las cifras. */
var LOC = document.documentElement.lang || 'en-US';
var IDIOMA = /^es/i.test(LOC) ? 'es' : 'en';
function t(k, v){
  var s = TX[k];
  if (s == null) return k;
  return v ? s.replace(/\{(\w+)\}/g, function(m, n){ return v[n] != null ? v[n] : m; }) : s;
}
function dinero(n){ return '$' + Math.round(n).toLocaleString(LOC); }

/* ── El selector de idioma ──────────────────────────────────────────────
   Quien elige a mano deja la cookie, y el middleware ya no lo manda a
   ningún lado por su Accept-Language. El mismo patrón que `Idioma.astro`. */
document.addEventListener('click', function(e){
  var a = e.target.closest && e.target.closest('[data-idioma]');
  if (a) document.cookie = 'idioma=' + a.getAttribute('data-idioma') + '; path=/; max-age=31536000; SameSite=Lax';
});

/* ── Menú ──────────────────────────────────────────────────────────────
   IIFE propia y sin globales. Va aparte del telar y de la consola a
   propósito: si el WebGL no carga, el menú tiene que seguir abriéndose.
   Cada pieza comprueba su elemento antes de tocarlo.
   ────────────────────────────────────────────────────────────────────── */
(function(){
  'use strict';
  var cab = document.getElementById('nv');
  if (!cab) return;

  var items = [].slice.call(cab.querySelectorAll('.nv-it')),
      prog  = document.getElementById('nv-prog'),
      ham   = document.getElementById('nv-ham'),
      mm    = document.getElementById('nv-mm'),
      caja  = mm ? mm.querySelector('.nv-caja') : null,
      cerrarBtn = document.getElementById('nv-cerrar'),
      grupos = mm ? [].slice.call(mm.querySelectorAll('.nv-gr')) : [],
      anchoAmplio = window.matchMedia('(min-width:981px)');

  /* 1 · La altura real del header, publicada como variable: los paneles
        cuelgan de ella y la siguen cuando la barra se compacta. */
  function medir(){ cab.style.setProperty('--nv-h', cab.offsetHeight + 'px'); }
  medir();
  window.addEventListener('resize', medir);

  /* 2 · Reacción al scroll: fondo + hilo de progreso.

        El alto del documento va en caché. Antes se leía
        `documentElement.scrollHeight` en cada cuadro, y esa lectura obliga al
        navegador a recalcular la disposición entera ahí mismo, justo después
        de que otro manejador haya escrito estilos: 38,9 ms de «forced
        reflow» medidos en un solo desplazamiento. El alto del documento no
        cambia al desplazarse —solo al cambiar el tamaño o el contenido—, así
        que se mide cuando eso pasa y no sesenta veces por segundo. */
  var pendiente = false, baja = null, altoDoc = 0;

  function remedirDoc(){ altoDoc = document.documentElement.scrollHeight - window.innerHeight; }

  function pintar(){
    pendiente = false;
    /* Leer primero, escribir después: `pageYOffset` no fuerza recálculo. */
    var y = window.pageYOffset || document.documentElement.scrollTop || 0,
        ahora = y > 14;
    if (prog) prog.style.transform = 'scaleX(' + (altoDoc > 0 ? Math.min(1, Math.max(0, y / altoDoc)) : 0) + ')';
    /* Esto sí escribe y luego mide, pero solo al cruzar el umbral —dos veces
       por visita, no por cuadro—: la barra cambia de alto y hay que leerlo. */
    if (ahora !== baja){ baja = ahora; cab.classList.toggle('nv-baja', ahora); medir(); }
  }
  function alScroll(){ if (!pendiente){ pendiente = true; requestAnimationFrame(pintar); } }
  window.addEventListener('scroll', alScroll, {passive:true});
  window.addEventListener('resize', function(){ remedirDoc(); alScroll(); });
  if ('ResizeObserver' in window) new ResizeObserver(remedirDoc).observe(document.body);
  remedirDoc();
  pintar();

  /* 3 · Desplegables. El CSS los abre con :hover para que funcionen aun sin
        JS; aquí se añade el estado explícito (data-open + aria-expanded) que
        es el que usan el teclado y el puntero cuando cruza el hueco entre
        el ítem y el panel. */
  function abrir(it, si){
    it.setAttribute('data-open', si ? 'true' : 'false');
    var b = it.querySelector('.nv-chv');
    if (b) b.setAttribute('aria-expanded', si ? 'true' : 'false');
  }
  function cerrarTodos(menos){
    items.forEach(function(it){ if (it !== menos) abrir(it, false); });
  }

  items.forEach(function(it){
    var b = it.querySelector('.nv-chv');
    if (!b) return;
    var antes = false, trasEsc = false;

    /* Con ratón, el focusin del propio clic abriría el panel justo antes de
       que el clic intente cerrarlo. Se recuerda el estado previo al apretar. */
    b.addEventListener('pointerdown', function(){ antes = it.getAttribute('data-open') === 'true'; });
    b.addEventListener('click', function(e){
      e.preventDefault();
      var estaba = e.detail > 0 ? antes : it.getAttribute('data-open') === 'true';
      cerrarTodos(it);
      abrir(it, !estaba);
      if (!estaba && e.detail === 0){
        var p = it.querySelector('.nv-pan a');
        if (p) p.focus();
      }
    });
    b.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown' || e.key === 'Down'){
        e.preventDefault(); cerrarTodos(it); abrir(it, true);
        var p = it.querySelector('.nv-pan a'); if (p) p.focus();
      }
    });

    /* Abrir con foco: tabular hasta el ítem despliega su panel. */
    it.addEventListener('focusin', function(){
      /* Escape devuelve el foco al botón, y ese movimiento volvía a disparar
         este focusin: sin la bandera, cerrar con Escape reabría el panel. */
      if (trasEsc){ trasEsc = false; return; }
      cerrarTodos(it); abrir(it, true);
    });
    it.addEventListener('focusout', function(e){
      /* La bandera solo se limpia cuando el foco abandona el ítem entero:
         focusout se dispara ANTES que focusin, y limpiarla aquí sin más
         dejaba que el foco devuelto por Escape reabriera el panel. */
      if (!it.contains(e.relatedTarget)){ trasEsc = false; abrir(it, false); }
    });
    it.addEventListener('mouseenter', function(){ cerrarTodos(it); abrir(it, true); });
    it.addEventListener('keydown', function(e){
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      abrir(it, false);
      if (b && document.activeElement !== b){ trasEsc = true; b.focus(); }
    });
    it.addEventListener('click', function(e){
      if (e.target.closest('a')) cerrarTodos(null);
    });
  });

  /* El puntero cierra al abandonar la barra entera, no el ítem: entre el
     ítem y el panel hay el relleno del header, y cerrar ahí haría el menú
     inalcanzable con el ratón. */
  cab.addEventListener('mouseleave', function(){ cerrarTodos(null); });
  document.addEventListener('click', function(e){ if (!cab.contains(e.target)) cerrarTodos(null); });
  window.addEventListener('scroll', function(){ cerrarTodos(null); }, {passive:true});

  /* 4 · Sección en pantalla. El observador propio marca el ítem cuyo
        data-sec contiene el id, y pinta el header con el acento de ese
        capítulo — los cuatro colores van rotando solos al bajar. */
  function marcar(id, acento){
    if (acento) cab.style.setProperty('--h', acento);
    items.concat(grupos).forEach(function(n){
      var suyas = (n.getAttribute('data-sec') || '').split(/\s+/),
          si = suyas.indexOf(id) > -1;
      n.classList.toggle('act', si);
      var a = n.querySelector('.nv-top');
      if (a){ if (si) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }
    });
  }
  var secs = [].slice.call(document.querySelectorAll('main section[id]'));
  if (secs.length && 'IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entradas){
      entradas.forEach(function(en){
        if (en.isIntersecting) marcar(en.target.id, (en.target.style.getPropertyValue('--h') || '').trim());
      });
    }, {rootMargin:'-45% 0px -50% 0px', threshold:0});
    secs.forEach(function(s){ obs.observe(s); });
  }

  /* 5 · Acordeones del panel. En escritorio el índice se ve entero. */
  function acordeon(b, si){
    var p = document.getElementById(b.getAttribute('aria-controls'));
    if (!p) return;
    b.setAttribute('aria-expanded', si ? 'true' : 'false');
    p.hidden = !si;
  }
  var botonesAc = mm ? [].slice.call(mm.querySelectorAll('.nv-ac')) : [];
  botonesAc.forEach(function(b){
    b.addEventListener('click', function(){ acordeon(b, b.getAttribute('aria-expanded') !== 'true'); });
  });

  /* 6 · El panel. Escape, clic fuera, clic en un enlace, y el foco vuelve
        a donde estaba. */
  if (ham && mm && caja){
    var previo = null;

    function abrirMM(){
      previo = document.activeElement;
      cerrarTodos(null);
      mm.hidden = false;
      ham.setAttribute('aria-expanded', 'true');
      ham.setAttribute('aria-label', t('nav.cerrar'));
      document.body.style.overflow = 'hidden';
      if (anchoAmplio.matches) botonesAc.forEach(function(b){ acordeon(b, true); });
      requestAnimationFrame(function(){ mm.classList.add('nv-on'); });
      var f = cerrarBtn || mm.querySelector('a,button');
      if (f) f.focus();
    }
    function cerrarMM(){
      mm.classList.remove('nv-on');
      mm.hidden = true;
      ham.setAttribute('aria-expanded', 'false');
      ham.setAttribute('aria-label', t('nav.abrir'));
      document.body.style.overflow = '';
      if (previo && previo.focus) previo.focus();
      previo = null;
    }

    ham.addEventListener('click', function(){
      if (mm.hidden) abrirMM(); else cerrarMM();
    });
    if (cerrarBtn) cerrarBtn.addEventListener('click', cerrarMM);

    /* Tocar fuera de la caja: por eso la caja no llega al borde inferior. */
    mm.addEventListener('click', function(e){
      if (!caja.contains(e.target)) { cerrarMM(); return; }
      if (e.target.closest('a')) cerrarMM();
    });

    /* Foco atrapado mientras está abierto, y Escape para salir. */
    mm.addEventListener('keydown', function(e){
      if (e.key === 'Escape' || e.key === 'Esc'){ e.preventDefault(); cerrarMM(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(mm.querySelectorAll('a[href],button:not([disabled])'))
               .filter(function(n){ return n.offsetWidth || n.offsetHeight || n.getClientRects().length; });
      if (!f.length) return;
      var pri = f[0], ult = f[f.length - 1];
      if (e.shiftKey && document.activeElement === pri){ e.preventDefault(); ult.focus(); }
      else if (!e.shiftKey && document.activeElement === ult){ e.preventDefault(); pri.focus(); }
    });

    /* Al pasar a escritorio con el panel abierto, se despliega el índice. */
    var alCambiar = function(){ if (!mm.hidden && anchoAmplio.matches) botonesAc.forEach(function(b){ acordeon(b, true); }); };
    if (anchoAmplio.addEventListener) anchoAmplio.addEventListener('change', alCambiar);
    else if (anchoAmplio.addListener) anchoAmplio.addListener(alCambiar);
  }
})();

  /* ── 02 · El libro de mediciones se enciende en secuencia ────────────
     Las filas se marcan de arriba abajo, como el instrumento recorriendo
     sus pasos. El estado apagado lo pone el JS (`chq-arm`), nunca el CSS
     solo: si este script no corre, el bloque queda encendido y legible.
     Con `prefers-reduced-motion` ni se arma.

     El bloque no se arma al cargar, sino en el primer desplazamiento: quien
     llega y no baja no tiene por qué ver seis filas a medio encender
     esperando el seguro de los 6 s. No cambia nada de lo que se ve —las
     filas empiezan bajo el pliegue y el observador remata 230 px después—.

     Lo que el apagado NO hace es tocar el texto: eso está en `.chq-arm` del
     CSS, y el porqué también. Aquí basta saber que una fila apagada se lee
     igual de bien que una encendida. */
  (function(){
    var blo = document.getElementById('chequeo');
    if (!blo) return;
    var filas = blo.querySelectorAll('.chq-l > li');
    if (!filas.length) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    var encender = function(){
      for (var i = 0; i < filas.length; i++) filas[i].classList.add('chq-on');
    };

    function armar(){
      window.removeEventListener('scroll', armar);
      blo.classList.add('chq-arm');
      /* Seguro: pase lo que pase, a los 6 s todo está encendido. */
      var red = setTimeout(encender, 6000);

      var corrio = false;
      var ob = new IntersectionObserver(function(entradas){
        for (var i = 0; i < entradas.length; i++) {
          if (!entradas[i].isIntersecting || corrio) continue;
          corrio = true;
          ob.disconnect();
          clearTimeout(red);
          filas.forEach(function(li, n){
            setTimeout(function(){ li.classList.add('chq-on'); }, 620 + n * 180);
          });
        }
      }, { threshold: .2 });
      ob.observe(blo);
    }

    /* Si se recarga con la página ya bajada, no hay que esperar al primer
       desplazamiento: el bloque puede estar ya en pantalla. */
    if (window.pageYOffset > 0) armar();
    else window.addEventListener('scroll', armar, { passive: true, once: true });
  })();

/* ── La consola: calificar, medir, leer ─────────────────────────────
   Sustituye al bloque «La consola» de la IIFE actual. El menú móvil no
   va aquí: es otra pieza.

   Tres cosas que nunca se mezclan, ni en la pantalla ni en el código:
     · lo que midió el servidor  → los puntajes, los hallazgos, la evidencia,
     · lo que contestó la persona → cuatro preguntas, ninguna obligatoria,
     · lo que se deduce de cruzarlas → el bloque ámbar, rotulado como tal.
   Si la recomendación se vistiera como los puntajes estaríamos vendiendo
   una opinión con el aspecto de un dato, que es justo lo que este sitio
   dice no hacer.

   La medición arranca al enviar la dirección y corre MIENTRAS se contestan
   las preguntas: cuarenta segundos de spinner son una fuga; cuarenta
   segundos contestando cuatro preguntas son el tramo más útil del embudo.

   Todo lo que vuelve del servidor entra con textContent. Ese texto lo
   escriben el sitio auditado y el modelo: es texto ajeno. */
(function(){
  'use strict';

  var raiz = document.getElementById('dg');
  if (!raiz) return;

  var pasos = [].slice.call(raiz.querySelectorAll('.dg-paso'));
  var riel  = [].slice.call(raiz.querySelectorAll('#dg-riel li'));
  function $(id){ return document.getElementById(id); }

  var est = { rama:'', sitio:'', sector:'', datos:null, err:null, t0:0, reloj:null, actual:'bif' };

  /* ── Navegación entre pasos ── */
  var ROT = { a: t('dg.rot.a').split('|'), b: t('dg.rot.b').split('|') };
  var ETAPA = { bif:1, url:1, quiz:2, obra:3, res:4, quizb:2, plan:3 };

  function pintarRiel(p){
    var rama = est.rama === 'b' ? 'b' : 'a';
    var n = ETAPA[p] || 1;
    riel.forEach(function(li, i){
      var t = ROT[rama][i];
      li.querySelector('b').textContent = t;
      li.hidden = !t;
      li.removeAttribute('data-e');
      if (i + 1 < n) li.setAttribute('data-e', 'ok');
      else if (i + 1 === n) li.setAttribute('data-e', 'on');
    });
  }

  function irA(p, callado){
    pasos.forEach(function(n){ n.hidden = n.getAttribute('data-paso') !== p; });
    est.actual = p;
    pintarRiel(p);
    if (!callado) {
      var h = raiz.querySelector('.dg-paso[data-paso="' + p + '"] .dg-h');
      if (h) h.focus();   /* el foco arrastra la vista: un solo gesto para las dos cosas */
    }
    if (p === 'obra') entrarObra();
  }

  raiz.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!b || !raiz.contains(b)) return;

    if (b.hasAttribute('data-rama')) {
      est.rama = b.getAttribute('data-rama');
      irA(est.rama === 'a' ? 'url' : 'quizb');
      return;
    }
    if (b.hasAttribute('data-va')) {
      var d = b.getAttribute('data-va');
      if (d === 'bif') { est.rama = ''; detener(); }
      if (d === 'url') detener();
      irA(d);
      return;
    }
    if (b.hasAttribute('data-acc')) {
      var a = b.getAttribute('data-acc');
      if (a === 'retry') { lanzar(); irA('obra'); }
      else if (a === 'rutab') { est.rama = 'b'; detener(); irA('quizb'); }
      else if (a === 'quiz') irA('quiz');
    }
  });

  /* ── A1 · la dirección ── */
  $('dg-f-url').addEventListener('submit', function(e){
    e.preventDefault();
    var crudo = ($('dg-sitio').value || '').trim();
    var limpio = crudo.replace(/^https?:\/\//i, '');
    /* Validación local, no para ahorrarle trabajo al servidor sino para no
       hacer esperar treinta segundos a quien escribió mal el dominio. */
    if (!/^[^\s\/.]+(\.[^\s\/.]{2,})+/.test(limpio)) {
      $('dg-url-err-t').textContent = t('dg.url.t');
      $('dg-url-err-p').textContent = t('dg.url.p');
      $('dg-url-err').hidden = false;
      $('dg-sitio').focus();
      return;
    }
    $('dg-url-err').hidden = true;
    est.sitio  = crudo;
    est.sector = $('dg-sector').value || '';
    lanzar();
    irA('quiz');
  });

  /* ── La medición ── */
  function lanzar(){
    est.datos = null; est.err = null; est.t0 = Date.now();
    reiniciarFases();
    $('dg-tira').removeAttribute('data-e');
    $('dg-tira-t').textContent = t('dg.midiendo', { sitio: est.sitio || t('dg.tusitio') });
    $('dg-tira-s').textContent = '0s';
    $('dg-obra-url').textContent = est.sitio || '—';
    arrancarReloj();

    /* Sin esto, un servidor que no contesta dejaba la barra colgada en el
       94 % contando segundos para siempre: ni error, ni salida. La auditoría
       real tarda decenas de segundos, así que el corte es generoso —pero
       existe— y cae en el mismo camino de error que ya está escrito. */
    var corte = null;
    var aborta = ('AbortController' in window) ? new AbortController() : null;
    if (aborta) corte = setTimeout(function(){ est.venció = true; aborta.abort(); }, 75000);

    fetch('/api/diagnostico', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sitio: est.sitio, sector: est.sector, idioma: IDIOMA }),
      signal: aborta ? aborta.signal : undefined
    })
    .then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(d){ return { ok:r.ok, s:r.status, d:d }; });
    })
    .then(function(res){
      if (res.ok) est.datos = res.d;
      else est.err = traducirError(res.s, res.d && res.d.error);
    })
    .catch(function(){ est.err = traducirError(est.venció ? 408 : 0, ''); })
    .then(function(){ if (corte) clearTimeout(corte); est.venció = false; llego(); });
  }

  /* El reloj es real: cuenta los segundos que de verdad lleva el servidor.
     La barra se acerca al 94 % de forma asintótica y solo la respuesta la
     cierra — una barra que llega al 100 % sola es una barra que miente. */
  var UMBRAL = [0, 3, 7, 11, 16, 23];

  function arrancarReloj(){ detener(); est.reloj = setInterval(tic, 250); tic(); }
  function detener(){ if (est.reloj) { clearInterval(est.reloj); est.reloj = null; } }

  function tic(){
    var s = (Date.now() - est.t0) / 1000;
    var pct = Math.round(94 * (1 - Math.exp(-s / 15)));
    $('dg-obra-bar').style.width = pct + '%';
    $('dg-obra-pct').textContent = pct + '%';
    $('dg-obra-s').textContent = Math.floor(s) + 's';
    $('dg-tira-s').textContent = Math.floor(s) + 's';
    var i = 0;
    for (var k = 0; k < UMBRAL.length; k++) if (s >= UMBRAL[k]) i = k;
    marcarFases(i, false);
  }

  var FASE = t('dg.fase').split('|');   /* en espera · en curso · listo */
  function marcarFases(activa, todo){
    var li = $('dg-fases').children;
    for (var k = 0; k < li.length; k++) {
      var e = (todo || k < activa) ? 'ok' : (k === activa ? 'on' : '');
      if (e) li[k].setAttribute('data-e', e); else li[k].removeAttribute('data-e');
      var em = li[k].querySelector('em');
      if (em) em.textContent = FASE[e === 'ok' ? 2 : e === 'on' ? 1 : 0];
    }
  }
  function reiniciarFases(){
    marcarFases(-1, false);
    $('dg-obra-bar').style.width = '0%';
    $('dg-obra-pct').textContent = '0%';
  }

  function llego(){
    detener();
    if (est.actual === 'obra') { rematar(); return; }
    /* Sigue contestando: la tira le dice que ya está, sin sacarlo de ahí. */
    var tira = $('dg-tira');
    if (est.err) {
      tira.setAttribute('data-e', 'mal');
      $('dg-tira-t').textContent = t('dg.tira.mal');
    } else {
      tira.setAttribute('data-e', 'ok');
      $('dg-tira-t').textContent = t('dg.tira.ok');
    }
  }

  function entrarObra(){
    $('dg-obra').hidden = false;
    $('dg-err').hidden = true;
    $('dg-err-acc').hidden = true;
    $('dg-obra-h').textContent = t('dg.obra');
    $('dg-obra-url').textContent = est.sitio || '—';
    if (est.datos || est.err) rematar();
  }

  function rematar(){
    if (est.err) { mostrarError(); return; }
    if (!est.datos) return;
    marcarFases(0, true);
    $('dg-obra-bar').style.width = '100%';
    $('dg-obra-pct').textContent = '100%';
    setTimeout(function(){ pintar(est.datos); irA('res'); }, 420);
  }

  /* ── Los errores dicen qué hacer ── */
  var ERRS = [400, 422, 502, 408, 0];
  function traducirError(s, txt){
    var k = 'err.' + (ERRS.indexOf(s) > -1 ? s : 'x');
    return { t:t(k + '.t'), p:t(k + '.p'), d:(typeof txt === 'string' && txt) ? txt : '' };
  }
  function mostrarError(){
    detener();
    $('dg-obra').hidden = true;
    $('dg-obra-h').textContent = t('dg.obra.mal');
    $('dg-err-t').textContent = est.err.t;
    $('dg-err-p').textContent = est.err.p;
    $('dg-err-d').textContent = est.err.d ? t('dg.dijo', { d: est.err.d }) : '';
    $('dg-err-d').hidden = !est.err.d;
    $('dg-err').hidden = false;
    $('dg-err-acc').hidden = false;
  }

  /* ── A2 · las cuatro preguntas ── */
  $('dg-f-quiz').addEventListener('submit', function(e){ e.preventDefault(); irA('obra'); });

  function valor(nombre){
    var i = raiz.querySelector('input[name="' + nombre + '"]:checked');
    return i ? i.value : '';
  }

  /* ── A4 · el resultado ── */
  /* Rótulo del diccionario si lo hay; si no, lo que vino del servidor. */
  function rot(pre, v){ return TX[pre + v] || v; }

  function marcador(b, bar, v){
    b.textContent = '';
    if (v === null || v === undefined || isNaN(Number(v))) { b.textContent = '—'; bar.style.width = '0%'; return; }
    var n = Math.round(Number(v));
    b.appendChild(document.createTextNode(String(n)));
    var u = document.createElement('u'); u.textContent = '/100'; b.appendChild(u);
    bar.style.width = '0%';
    requestAnimationFrame(function(){ bar.style.width = Math.max(0, Math.min(100, n)) + '%'; });
  }

  function pildora(txt, fuerte){
    var s = document.createElement('span');
    s.textContent = txt;
    if (fuerte) s.className = 'sev';
    return s;
  }

  function pintar(d){
    d = d || {};
    marcador($('dg-fuga'), $('dg-fuga-b'), d.indice_fuga);
    marcador($('dg-seo'),  $('dg-seo-b'),  d.salud_seo);
    marcador($('dg-ia'),   $('dg-ia-b'),   d.visibilidad_ia);
    $('dg-vered').textContent = d.veredicto || '';

    /* Dos hallazgos, no los quince. El resto vive en el informe, y se abre
       dejando el correo: prometer quince y enseñar dos sin decirlo sería
       exactamente la fuga que acabamos de medirle a otro. */
    var ul = $('dg-hall');
    ul.textContent = '';
    var hs = Array.isArray(d.hallazgos) ? d.hallazgos : [];
    var tonos = ['var(--rojo)', 'var(--ambar)'];
    hs.slice(0, 2).forEach(function(h, i){
      h = h || {};
      var li = document.createElement('li');
      li.style.setProperty('--h', tonos[i % tonos.length]);
      var pl = document.createElement('div'); pl.className = 'pl';
      pl.appendChild(pildora(h.severidad ? rot('sev.', h.severidad) : t('sev.x'), true));
      if (h.esfuerzo) pl.appendChild(pildora(rot('esf.', h.esfuerzo), false));
      if (h.hilo) pl.appendChild(pildora(rot('hilo.', h.hilo), false));
      var b = document.createElement('b'); b.textContent = h.titulo || '';
      var p = document.createElement('p'); p.textContent = h.evidencia || '';
      li.appendChild(pl); li.appendChild(b); li.appendChild(p);
      ul.appendChild(li);
    });

    var resto   = Math.max(0, hs.length - 2);
    var buenos  = Array.isArray(d.aciertos) ? d.aciertos.length : 0;
    $('dg-cofre-t').textContent = resto
      ? t('cofre.t', { n: resto, buenos: buenos ? t('cofre.buenos', { n: buenos }) : '' })
      : t('cofre.t0');
    $('dg-cofre-b').textContent = resto ? t('cofre.b', { n: resto }) : t('cofre.b0');
    $('dg-mas').textContent = resto ? t('cofre.mas', { n: resto }) : t('cofre.mas0');

    var trozos = [];
    if (d.url) trozos.push(d.url);
    trozos.push(t('pie.medido') + (d.medido_en ? t('pie.el', { f: String(d.medido_en).slice(0, 10) }) : ''));
    if (d.tecnologia && d.tecnologia.plataforma) trozos.push(t('pie.base', { p: d.tecnologia.plataforma }));
    var bb = d.geo && d.geo.bots_bloqueados;
    var nb = Array.isArray(bb) ? bb.length : (typeof bb === 'number' ? bb : null);
    if (nb !== null) trozos.push(nb === 0 ? t('pie.bots0') : t('pie.bots', { n: nb }));
    $('dg-pie').textContent = '⟨ ' + trozos.join(' · ') + ' ⟩';

    leer();
  }

  /* ── La lectura. No es una métrica: es lo que dicen sus respuestas.
     Va en su caja, con su rótulo, y jamás lleva un número. ── */
  /* Las frases salen del diccionario: `mide.<respuesta>`, `halla.…`,
     `venta.…`, `proc.…`; los paquetes, de `paq.<paquete>.*`. */

  function leer(){
    var r = { venta:valor('dg-venta'), halla:valor('dg-halla'), mide:valor('dg-mide'), proc:valor('dg-proc') };
    var frases = [];
    ['mide', 'halla', 'venta', 'proc'].forEach(function(k){
      if (r[k] && TX[k + '.' + r[k]]) frases.push(TX[k + '.' + r[k]]);
    });

    if (!frases.length) {
      $('dg-lee-p').textContent = t('lee.vacio');
      $('dg-lee-rec').hidden = true;
      $('dg-vuelve-quiz').hidden = false;
      return;
    }
    $('dg-vuelve-quiz').hidden = true;
    $('dg-lee-p').textContent = frases.join(' ');

    var citas  = (r.venta === 'persona' || r.venta === 'tel');
    var suelto = (r.proc === 'manual' || r.proc === 'hoja' || r.proc === 'pierdo');
    recomendar('dg-lee-rec', (citas && suelto) ? 'booking' : 'essential');
    $('dg-lee-rec').hidden = false;
  }

  /* ── B · sin sitio: no hay nada que medir, y se dice así ──
     Esta rama no imita a la otra. Sin puntajes, sin índice y sin barra:
     lo único con cifra es la multiplicación de dos números que escribió la
     propia persona, rotulada como suya. Inventar aquí un «índice de fuga»
     sería inventar una medición de un sitio que no existe. */
  /* Sus frases: `b.<dónde la hallan>` y `b.paq.<paquete>` en el diccionario. */

  /* El paquete que toca, con su precio y su porqué. Lo usan las dos ramas. */
  function recomendar(id, paq){
    var b = $(id + '-t');
    b.textContent = t('lee.rec', { n: t('paq.' + paq + '.n') });
    var u = document.createElement('u'); u.textContent = t('paq.' + paq + '.pr'); b.appendChild(u);
    $(id + '-p').textContent = t('paq.' + paq + '.p') + t('paq.cola');
  }

  $('dg-f-quizb').addEventListener('submit', function(e){
    e.preventDefault();
    planear();
    irA('plan');
  });

  function planear(){
    var sector = $('dg-b-sector').value || '';
    var halla  = valor('dg-b-halla');
    var cobra  = valor('dg-b-cobra');
    var n = parseFloat($('dg-b-n').value);
    var v = parseFloat($('dg-b-v').value);

    var lead = TX['b.' + halla] || t('b._');
    if (sector) lead += t('b.sector', { sector: sector.toLowerCase() });
    $('dg-plan-lead').textContent = lead;

    if (n > 0 && v > 0) {
      $('dg-plan-rot').textContent = t('b.rot.n', { n: Math.round(n), v: dinero(v) });
      var c = $('dg-plan-cifra');
      c.textContent = dinero(n * v);
      var cu = document.createElement('u'); cu.textContent = t('b.mes'); c.appendChild(cu);
      $('dg-plan-p').textContent = t('b.p');
    } else {
      $('dg-plan-rot').textContent = t('b.rot');
      $('dg-plan-cifra').textContent = '—';
      $('dg-plan-p').textContent = t('b.p0');
    }

    var paq = (cobra === 'cita' || cobra === 'llaman' || cobra === 'mensaje') ? 'booking' : 'essential';
    var lee = t('b.paq.' + paq);
    if (halla === 'redes' || halla === 'market') lee += t('b.propio');
    if (!sector && !halla && !cobra && !(n > 0 && v > 0)) lee = t('b.vacio');
    $('dg-plan-lee').textContent = lee;
    recomendar('dg-plan-rec', paq);
  }

  /* Lo poco que el modal de captación necesita saber de aquí: qué sitio se
     midió, de qué sector y qué contestó quien no tiene sitio. Un getter y no
     un objeto suelto, para que nadie escriba en el estado de la consola desde
     fuera. */
  window.__telarConsola = function(){
    return {
      rama: est.rama,
      sitio: est.sitio,
      sector: est.sector || $('dg-b-sector').value || '',
      medido: !!est.datos,
      respuestas: {
        sector: $('dg-b-sector').value || '',
        halla: valor('dg-b-halla'),
        cobra: valor('dg-b-cobra'),
        clientes: $('dg-b-n').value || '',
        valor: $('dg-b-v').value || ''
      }
    };
  };

  irA('bif', true);
})();

/* ── PIEZA A — el hilo que se teje ─────────────────────────────────────
   Un solo listener pasivo, una escritura por cuadro dentro de rAF. Con
   prefers-reduced-motion no se instala nada: el hilo aparece entero y los
   cuatro pasos encendidos, que es el estado final. */
(function(){
  'use strict';
  var caja = document.getElementById('pr-pasos');
  if (!caja) return;
  var pasos = [].slice.call(caja.querySelectorAll('.pr-p'));
  var quieto = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* A partir de aquí manda el script: antes de esto el bloque se ve
     completo, que es el estado correcto si el JS nunca llega. */
  caja.classList.add('pr-anima');

  if (quieto) {
    caja.style.setProperty('--t', '1');
    pasos.forEach(function(p){ p.classList.add('on'); });
    return;
  }

  var umbral = [0, .26, .52, .78], pedido = false, ultimo = -1;

  /* La posición del bloque dentro del documento y su altura no cambian al
     desplazarse: solo al cambiar el tamaño o el contenido. Se guardan en
     caché. `getBoundingClientRect()` en cada cuadro obligaba a recalcular la
     disposición justo después de que el manejador del header hubiera escrito
     su `transform`, que es el patrón exacto del «forced reflow». */
  var arriba = 0, alto = 0, sucio = true;
  function remedir(){
    var r = caja.getBoundingClientRect();
    arriba = r.top + (window.pageYOffset || 0);
    alto = r.height;
    sucio = false;
  }
  function ensuciar(){ sucio = true; pedir(); }

  function tejer(){
    pedido = false;
    if (sucio) remedir();                     /* única lectura, y solo si hace falta */
    var vh = window.innerHeight || 1;
    var top = arriba - (window.pageYOffset || 0);
    /* 0 cuando el bloque asoma por abajo, 1 cuando ya pasó su altura. */
    var t = (vh * .82 - top) / (alto + vh * .18);
    t = t < 0 ? 0 : t > 1 ? 1 : t;
    if (Math.abs(t - ultimo) < .004) return;
    ultimo = t;
    caja.style.setProperty('--t', t.toFixed(3));
    for (var i = 0; i < pasos.length; i++) pasos[i].classList.toggle('on', t >= umbral[i]);
  }
  function pedir(){ if (!pedido) { pedido = true; requestAnimationFrame(tejer); } }

  addEventListener('scroll', pedir, { passive: true });
  addEventListener('resize', ensuciar, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(ensuciar).observe(document.body);
  tejer();
})();

/* ── PIEZA B — la columna activa ───────────────────────────────────────
   El hover lo hace el CSS. Esto sólo cubre lo que el hover no puede: un
   dedo. Se instala únicamente donde no hay puntero fino, para no pelearse
   con :hover en escritorio. */
(function(){
  'use strict';
  var pf = document.getElementById('pf');
  if (!pf) return;
  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

  var cols = [].slice.call(pf.querySelectorAll('.pf-col'));
  if (!cols.length) return;

  pf.addEventListener('click', function(e){
    var col = e.target.closest ? e.target.closest('.pf-col') : null;
    if (!col || !pf.contains(col)) return;
    if (e.target.closest('a')) return;          /* el enlace manda */
    cols.forEach(function(c){ c.classList.toggle('on', c === col && !col.classList.contains('on')); });
  });
})();

/* ── PIEZA B bis — ninguna columna se queda sin pedir su foto ──────────
   En teléfono `.pf` es un carrusel horizontal: la cuarta columna nace a
   más de dos anchos de pantalla a la derecha, y una imagen `lazy` que
   nunca se acerca al puerto de vista es una imagen que el navegador
   sencillamente no pide. No falla la petición — no la hay. Encima el
   umbral de la carga diferida no es fijo: depende de la conexión que
   Chrome estime, así que en una red lenta la columna puede quedarse en
   blanco justo donde más se mira.

   El seguro: cuando el capítulo entra en pantalla, lo que siga en
   diferido pasa a carga normal. Sigue fuera del arranque de la página
   —que es lo que protege el LCP— pero deja de depender de que alguien
   arrastre el carrusel hasta el final. */
(function(){
  'use strict';
  var pf = document.getElementById('pf');
  if (!pf || !('IntersectionObserver' in window)) return;

  var obs = new IntersectionObserver(function(entradas){
    var visible = entradas.some(function(e){ return e.isIntersecting; });
    if (!visible) return;
    obs.disconnect();
    [].forEach.call(pf.querySelectorAll('img[loading="lazy"]'), function(im){
      if (!im.complete) im.loading = 'eager';
    });
  }, { rootMargin: '250px' });

  obs.observe(pf);
})();

/* ── Testimonios: puntos del carrusel ────────────────────────────────
   Un punto por tarjeta, creados desde el DOM: añadir o quitar un
   testimonio no obliga a tocar el JS ni el marcado de los puntos.
   En escritorio el CSS los esconde y esto no estorba. */
(function(){
  'use strict';
  var pista = document.getElementById('tst-pista'),
      caja  = document.getElementById('tst-puntos');
  if (!pista || !caja) return;

  var tarjetas = [].slice.call(pista.querySelectorAll('.tst-t'));
  if (tarjetas.length < 2) return;

  var quieto = window.matchMedia('(prefers-reduced-motion:reduce)').matches,
      puntos = [];

  tarjetas.forEach(function(tj, i){
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', t('tst.punto', { i: i + 1, n: tarjetas.length }));
    b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
    b.appendChild(document.createElement('i'));
    b.addEventListener('click', function(){
      pista.scrollTo({ left: tj.offsetLeft - pista.offsetLeft, behavior: quieto ? 'auto' : 'smooth' });
    });
    caja.appendChild(b);
    puntos.push(b);
  });

  function marcar(i){
    puntos.forEach(function(b, j){ b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(ent){
      ent.forEach(function(e){
        if (e.isIntersecting) marcar(tarjetas.indexOf(e.target));
      });
    }, { root: pista, threshold: .6 });
    tarjetas.forEach(function(t){ obs.observe(t); });
  }
})();


/* ── 02 · El muestrario: oficios y su mínimo ──────────────────────────
   IIFE propia, sin globales. El array de abajo es la fuente: añadir el
   oficio 40 es añadir una línea. Todo lo que sale de él entra al DOM con
   textContent — aquí no hay innerHTML ni con datos propios, porque la
   costumbre es lo que evita el accidente el día que el texto venga de
   fuera.
   Columnas: id · nombre · familia · sinónimos · páginas · funciones ·
             confianza · qué cuenta como conversión · plan · por qué */
(function(){
  'use strict';

  var raiz = document.getElementById('ng');
  if (!raiz) return;

  /* ── El catálogo llega al primer gesto ─────────────────────────────────
     Los 39 nombres y la rejilla ya están en el HTML: la sección se lee sin
     esto. Lo que falta son las 39 fichas con su prosa —25 kB, 9 kB en el
     cable— y solo hacen falta para buscar o para abrir una. Se piden al
     primer gesto, igual que la escena del telar, y así no pesan en el camino
     crítico del LCP de quien solo lee el titular.

     `scroll` no entra en la lista: abrir un ancla lo dispara sin que nadie
     haya tocado nada. Y el clic en un oficio también lo pide, por si alguien
     llega con el teclado antes de que haya pasado nada más. */
  /* Ruta absoluta y no `./catalogo.js`: este archivo es un script clásico, y
     ahí `import()` resuelve contra la URL del DOCUMENTO, no contra la del
     script. Servido en `/`, un `./` buscaría `/catalogo.js`. */
  /* Un archivo por idioma, con la misma forma: cada visitante baja solo el
     suyo. El español trae además `SLUG`, el id → la dirección en español. */
  var pedido = null;
  function catalogo(){
    if (!pedido) pedido = import(IDIOMA === 'es' ? '/tema/catalogo.es.js' : '/tema/catalogo.js')
      .then(function(m){ montar(m.CAT, m.FAMS, m.SLUG || {}); });
    return pedido;
  }
  var gestos = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
  var opciones = { passive: true, once: true };
  function soltar(){
    gestos.forEach(function(g){ removeEventListener(g, soltar, opciones); });
    catalogo();
  }
  gestos.forEach(function(g){ addEventListener(g, soltar, opciones); });

  /* La rejilla que viene servida ya son enlaces que funcionan sin JavaScript:
     si el catálogo no ha llegado, pulsar un oficio navega igual. Lo único que
     necesita los datos es buscar y filtrar, y eso se pide al enfocar el
     campo. */
  raiz.addEventListener('focusin', catalogo);

  function montar(CAT, FAMS, SLUG){
    raiz.setAttribute('data-vivo', '1');

    var caja   = document.getElementById('ng-busca'),
        ent    = document.getElementById('ng-q'),
        fams   = document.getElementById('ng-fams'),
        cuenta = document.getElementById('ng-cuenta'),
        rej    = document.getElementById('ng-rej'),
        est    = document.getElementById('ng-est');
    if (!ent || !fams || !rej || !est) return;

    var I = {id:0,nom:1,fam:2,syn:3};
    var color = {}, nomFam = {};
    FAMS.forEach(function(f){ color[f[0]] = f[2]; nomFam[f[0]] = f[1]; });

    /* Sin acentos y sin mayúsculas: quien escribe «masajes» y quien escribe
       «Masaje» buscan lo mismo. */
    function llano(s){
      s = String(s).toLowerCase();
      return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g,'') : s;
    }
    var indice = CAT.map(function(r){
      return llano(r[I.nom] + ' ' + r[I.syn] + ' ' + nomFam[r[I.fam]]);
    });

    function el(t, c, txt){
      var n = document.createElement(t);
      if (c) n.className = c;
      if (txt != null) n.textContent = txt;
      return n;
    }

    /* ── La ficha ya no vive aquí ──────────────────────────────────────
       Cada oficio tiene su página —`/trades/<id>` o `/es/oficios/<slug>`, generada del mismo
       catálogo— y los botones de la rejilla son enlaces a ella. Antes la
       ficha se desplegaba dentro: 1.400 px que hundían la sección por debajo
       del umbral del observador y la hacían desaparecer, y un contenido
       excelente que ningún buscador podía indexar porque no tenía URL.

       Lo que queda aquí es el índice: buscar, filtrar y entrar. */

    /* ── La rejilla ── */
    function pinta(vis){
      rej.textContent = '';
      if (!vis.length){
        rej.hidden = true;
        var v = el('div','ng-vacio');
        v.appendChild(el('b','',t('ng.vacio.t')));
        v.appendChild(el('p',null,t('ng.vacio.p')));
        var a = el('a',null,t('ng.vacio.a'));
        a.href = '#diagnostico';
        v.appendChild(a);
        rej.parentNode.insertBefore(v, rej.nextSibling);
        vacio = v;
        return;
      }
      rej.hidden = false;
      var frag = document.createDocumentFragment();
      vis.forEach(function(r){
        var b = el('a','ng-b');
        b.href = t('ng.ruta') + (SLUG[r[I.id]] || r[I.id]);
        b.style.setProperty('--f', color[r[I.fam]]);
        b.appendChild(el('span','ng-ini', r[I.nom].charAt(0)));
        b.appendChild(el('span','ng-nom', r[I.nom]));
        frag.appendChild(b);
      });
      rej.appendChild(frag);
    }

    var vacio = null, familia = '';
    function filtra(){
      if (vacio){ vacio.parentNode.removeChild(vacio); vacio = null; }
      var q = llano(ent.value.trim()),
          trozos = q ? q.split(/\s+/) : [],
          vis = CAT.filter(function(r, i){
            if (familia && r[I.fam] !== familia) return false;
            for (var k = 0; k < trozos.length; k++){
              if (indice[i].indexOf(trozos[k]) === -1) return false;
            }
            return true;
          });
      pinta(vis);
      cuenta.textContent = vis.length === CAT.length
        ? t('ng.cuenta', { n: CAT.length })
        : t('ng.cuenta.de', { v: vis.length, n: CAT.length });
    }

    /* ── Las familias ── */
    var botFam = [];
    function chip(id, nom, c){
      var b = el('button', null, nom);
      b.type = 'button';
      if (c) b.style.setProperty('--f', c);
      b.setAttribute('aria-pressed', id === '' ? 'true' : 'false');
      b.addEventListener('click', function(){
        familia = id;
        botFam.forEach(function(o){ o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        filtra();
      });
      botFam.push(b);
      fams.appendChild(b);
    }
    ent.addEventListener('input', filtra);
    /* Enter no envía nada: no hay formulario, y el resultado ya está pintado. */
    ent.addEventListener('keydown', function(e){ if (e.key === 'Enter') e.preventDefault(); });

    /* Los mandos y la rejilla ya vienen servidos en el HTML —el porqué está
       allí, y es de CLS—. Aquí se vuelven a montar, que es lo que les pone las
       escuchas, sobre exactamente el mismo contenido: mismo alto, nada se
       mueve. `est` no se toca: nace oculta y solo la devuelve el <noscript>. */
    fams.textContent = '';
    chip('', t('ng.todos', { n: CAT.length }), '');
    FAMS.forEach(function(f){ chip(f[0], f[1], f[2]); });
    filtra();
  }
})();


/* ── LA BARRA FIJA DE ACCIÓN ───────────────────────────────────────────────
   Se enciende cuando los botones del hero salen de pantalla y ya no se apaga:
   a partir de ahí, la puerta al diagnóstico viaja con el visitante.

   Un observador sobre `.hx-cta` y no un escuchador de `scroll`: el que mira
   no cuesta un cuadro y el otro sí, y esta página se midió hasta el 100.

   La clase en el <html> es para lo que la barra tapa — el banner de cookies
   se sube y el pie reserva su alto. Vive en el CSS, aquí solo se enciende. */
(function(){
  'use strict';
  var barra = document.getElementById('fija');
  var ancla = document.querySelector('.hx-cta');
  if (!barra || !ancla || !('IntersectionObserver' in window)) return;

  var raiz = document.documentElement;
  new IntersectionObserver(function(ent){
    var fuera = !ent[0].isIntersecting;
    barra.hidden = !fuera;
    raiz.classList.toggle('conbarra', fuera);
  }, { rootMargin: '0px 0px -12px 0px' }).observe(ancla);
})();

/* ── EL MODAL DE CAPTACIÓN ─────────────────────────────────────────────────
   El marcado lo sirve `src/components/Captacion.astro` —necesita los prefijos
   telefónicos y vive en el servidor—; aquí está lo que hace.

   Lo abre cualquier elemento con `data-cap="<origen>"`. Hoy son dos: el botón
   que desbloquea el informe completo (`informe-completo`, que hace que el
   servidor vuelva a medir el sitio y mande el informe entero por correo) y el
   de la ruta sin sitio (`plan-sitio`, que manda el plan). Los dos apuntaban a
   `/` y no hacían nada.

   El primer paso dice lo que de verdad va a llegar: con el sitio ya medido, el
   informe; sin medir, el plan. Prometer «tu informe completo» a quien nunca
   escribió una dirección sería prometer algo que no se puede medir. */
(function(){
  'use strict';
  var caja = document.getElementById('capt');
  if (!caja) return;

  var form   = document.getElementById('cap-f'),
      ok     = document.getElementById('cap-ok'),
      err    = document.getElementById('cap-err'),
      correo = document.getElementById('cap-correo'),
      pref   = document.getElementById('cap-pref'),
      tel    = document.getElementById('cap-tel'),
      boton  = document.getElementById('cap-enviar'),
      paso1  = document.getElementById('cap-p1'),
      baja   = document.getElementById('cap-baja');
  if (!form || !correo || !pref || !tel) return;

  var origen = 'informe-completo';
  var devolver = null;   /* a dónde vuelve el foco al cerrar */

  /* Lo que se manda de verdad en cada caso, y el texto entero que lo dice.
     Está en una tabla y no repartido por el marcado porque el modal se abre
     desde sitios distintos: prometer «tu informe completo» a quien nunca
     escribió una dirección sería prometer algo que no se puede medir. */
  /* Los textos de cada caso están en el diccionario bajo `cap.<caso>.*`:
     titular en dos trozos (`t1`, `t2`), bajada, primer paso, botón y acuse. */
  function consola(){
    try { return window.__telarConsola ? window.__telarConsola() : {}; }
    catch (e) { return {}; }
  }

  function abrir(quien, cual){
    origen = cual || 'informe-completo';
    devolver = quien || null;
    var c = consola();
    var k = 'cap.' + (origen === 'sistema' ? 'sistema'
                : origen === 'plan-sitio' ? 'plan'
                : (c.medido ? 'informe' : 'guia')) + '.';

    var h = document.getElementById('cap-t');
    if (h) {
      h.textContent = t(k + 't1');
      var em = document.createElement('span');
      em.className = 's';
      em.textContent = t(k + 't2');
      h.appendChild(em);
    }
    if (baja) baja.textContent = t(k + 'baja');
    if (paso1) paso1.textContent = t(k + 'paso1');
    if (boton) boton.textContent = t(k + 'boton');
    var okp = document.getElementById('cap-ok-p');
    if (okp) okp.textContent = t(k + 'ok');

    esconder(false);
    caja.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function(){ correo.focus(); }, 30);
  }

  function cerrar(){
    caja.hidden = true;
    document.documentElement.style.overflow = '';
    if (devolver && devolver.focus) devolver.focus();
    devolver = null;
  }

  /* Enviado no es borrado: el modal puede volver a abrirse desde otro botón,
     y entonces tiene que enseñar el formulario otra vez. */
  function esconder(enviado){
    form.hidden = !!enviado;
    if (ok) ok.hidden = !enviado;
    if (err) { err.hidden = true; err.textContent = ''; }
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('[data-cap]');
    if (t) { e.preventDefault(); abrir(t, t.getAttribute('data-cap')); return; }
    if (e.target.closest && e.target.closest('[data-cap-cerrar]')) { e.preventDefault(); cerrar(); }
  });

  addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !caja.hidden) cerrar();
  });

  function fallo(msg, campo){
    if (err) { err.textContent = msg; err.hidden = false; }
    if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    correo.removeAttribute('aria-invalid');
    tel.removeAttribute('aria-invalid');
    if (err) err.hidden = true;

    var dir = correo.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dir)) {
      return fallo(t('cap.err.correo'), correo);
    }

    /* El número se valida contra los dígitos reales del país, no contra «algo
       que parezca un teléfono». */
    var op = pref.options[pref.selectedIndex];
    var min = parseInt(op.getAttribute('data-min'), 10) || 6;
    var max = parseInt(op.getAttribute('data-max'), 10) || 15;
    var dig = tel.value.replace(/\D/g, '');
    if (dig.length < min || dig.length > max) {
      return fallo(t('cap.err.tel', { pref: op.value, tiene: dig.length,
        n: min === max ? min : t('cap.err.rango', { min: min, max: max }) }), tel);
    }

    var c = consola();
    var cuerpo = {
      origen: origen,
      idioma: IDIOMA,
      correo: dir,
      telefono: op.value + ' ' + dig,
      nombre: (document.getElementById('cap-nombre') || {}).value || null,
      empresa: (document.getElementById('cap-empresa') || {}).value || null,
      sitio: c.sitio || null,
      sector: c.sector || null
    };
    /* `plan-sitio` manda las respuestas del cuestionario en `reto`: el servidor
       arma el plan con ellas. Datos, no texto — lo que va en el correo lo
       escribe él. */
    if (origen === 'plan-sitio' && c.respuestas) cuerpo.reto = JSON.stringify(c.respuestas);

    boton.disabled = true;
    var antes = boton.textContent;
    boton.textContent = t('cap.enviando');

    fetch('/api/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(d){ return { ok: r.ok, d: d }; });
    }).then(function(res){
      boton.disabled = false;
      boton.textContent = antes;
      if (!res.ok) return fallo(res.d.error || t('cap.err.guardar'));
      esconder(true);
    }).catch(function(){
      boton.disabled = false;
      boton.textContent = antes;
      fallo(t('cap.err.red'));
    });
  });
})();

  /* ── Red de seguridad de `.vis` ──────────────────────────────────────
     El observador que enciende `.in` vive en telar.js, que antes de
     instalarlo importa Three.js y crea un contexto WebGL. Si eso falla
     —sin WebGL, con el ahorro de datos, o porque la red se cayó a mitad
     del módulo— el módulo muere ANTES de llegar al observador y las once
     secciones se quedan en `opacity:0`: la página entera en blanco por
     culpa de la decoración. telar.js no se toca; se sondea.

     Se instala YA, no a los 2,5 s. Esperar era esperar a Three.js: 420 kB
     gzip que el módulo importa antes de su primera línea, y hasta que no
     bajaban no se encendía nada. Con la red lenta eso son segundos de
     página en blanco en el peor momento posible — el primero. Este
     observador solo añade y deja de mirar lo que ya encendió, así que
     cuando telar.js llegue y ponga el suyo, los dos conviven. */
  (function(){
    'use strict';
    var caps = [].slice.call(document.querySelectorAll('.cap'));
    if (!caps.length) return;
    if (!('IntersectionObserver' in window)) {
      caps.forEach(function(c){ c.classList.add('vis'); });
      return;
    }
    var ob = new IntersectionObserver(function(ent){
      ent.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('vis');
        ob.unobserve(e.target);
      });
    }, { threshold: .12 });
    caps.forEach(function(c){ ob.observe(c); });
  })();
})();
